import React from "react";

const points = [
  "Instant Sharing – Photos, GIFs, and videos delivered instantly.",
  "Custom Branding – Logos, overlays, and filters that match your brand.",
  "Professional Lighting – Every shot looks studio-quality.",
  "Data Capture & Analytics (for brands) – Collect insights and boost engagement.",
  "Setup & Support – We handle everything from start to finish.",
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-slate-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="animate-fade-up">
            <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
              Why PixlyBooth
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Not just photos.
              <br />
              A complete experience.
            </h2>
            <p className="text-gray-300">
              From the moment we set up to the last photo snapped, our team ensures
              everything runs smoothly, looks amazing, and keeps your guests engaged.
            </p>
          </div>

          <ul className="space-y-3 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            {points.map((p) => (
              <li
                key={p}
                className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-2xl px-4 py-3"
              >
                <span className="mt-[3px] text-emerald-400 text-lg">✔</span>
                <p className="text-sm text-gray-100">{p}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
